import { sanitizedInjectHTML, Text } from '@visiba-cortex/react-ui-std';
import { tokens } from '@cellula/react-theme-patient';
import { usePresentation } from '@visiba/presentation';
import { Bleed, Box, Flex, SafeArea, Spacer, Stack } from '@cellula/react';
import styled from 'styled-components';
import { useCurrentLocation } from '../../application/use_current_location';
import { ReceptionHomeController } from './_reception_home.controller';
import { BreakPoints, useBreakpoint } from '@cellula/react';

interface ReceptionHeroProps {
	controller: ReceptionHomeController;
}

const elements = {
	container: styled.div`
		width: 100%;
		background-color: #fff;
		border-bottom: 1px solid #e5e8f0;
	`,
	logo: styled.div`
		height: 100%;
	`,
	img: styled.img`
		display: block;
		max-width: 100%;
		max-height: 240px;

		${tokens.breakpointQuery.small} {
			min-width: 235px;
			max-width: 272px;
		}

		${tokens.breakpointQuery.large} {
			max-width: 424px;
		}
	`,
};

export function ReceptionHomeHero({ controller }: ReceptionHeroProps): JSX.Element {
	const { textReceptionTitle: receptionTitleText, textReceptionBody: receptionBodyText } = usePresentation(controller.presentation);
	const [_, config] = useCurrentLocation();
	const breakpoint = useBreakpoint(BreakPoints.Small | BreakPoints.Medium);

	return (
		<Bleed viewportWide>
			<elements.container>
				<Spacer vertical={tokens.spacing.x9} />
				<SafeArea asChild maxWidth='1096px'>
					<Box data-testid='browse_reception' asChild verticalPadding={tokens.spacing.x2}>
						<Stack gap={tokens.spacing.x5}>
							<Flex
								fluid={breakpoint ? 'horizontal' : true}
								gap={tokens.spacing.x4}
								breakpointSmallAndUp={{
									gap: tokens.spacing.x9,
									direction: 'row',
								}}
							>
								<elements.logo>
									<elements.img src={(config?.theme.LogoUrl as string) ?? (config?.theme.EmailLogoUrl as string)} alt='' />
								</elements.logo>
								<Stack gap={tokens.spacing.x2_5}>
									<Text font={tokens.text.heading.large} color={tokens.color.content.default}>
										{receptionTitleText}
									</Text>
									<Text font={tokens.text.body.regular} color={tokens.color.content.default}>
										<span dangerouslySetInnerHTML={sanitizedInjectHTML(receptionBodyText)} />
									</Text>
								</Stack>
							</Flex>
						</Stack>
					</Box>
				</SafeArea>
				<Spacer vertical={tokens.spacing.x6} />
			</elements.container>
		</Bleed>
	);
}
